import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetCpdRegionsSucceed, EGetCpdRegionsActionType } from './types';
import { ICpdRegions } from '../../../types/cpdRegions';

export const getCpdRegionsSucceed: (data: ICpdRegions) => TGetCpdRegionsSucceed = actionGenerator<
  EGetCpdRegionsActionType.Succeed,
  ICpdRegions
>(EGetCpdRegionsActionType.Succeed);
